"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentBox = void 0;
/* eslint-disable react-native/no-inline-styles */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const DocumentBox_style_1 = require("./DocumentBox.style");
const atome_1 = require("../../atome");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const file_saver_1 = require("file-saver");
const TempDownloadButton_1 = require("./TempDownloadButton");
function DocumentBox({ type, ...props }) {
    const userInfo = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [showDelete, setShowDelete] = (0, react_1.useState)(false);
    const [showUploadError, setShowUploadError] = (0, react_1.useState)(false);
    const [uploadFileName, setUploadFileName] = (0, react_1.useState)('');
    /**
     * Takes a file name with its' extension and checks whether it includes
     * special characters or not. Dots are handled separately because they
     * are special chars that need to be part of the string only once but
     * need to be replaced in any other place.
     *
     * @param fileName A string with the name of the file (extension included)
     * @returns A formatted file name that has all special characters replaced with _
     */
    const formatFileName = (fileName) => {
        /**
         * (?=[~:!\@\#$\%\^\&\*\(\)\+\=\{\};:'"|/\?><,\\\[\]\t\s\n]) => look ahead in the string for special chars, tabs, spaces, line breaks (except dots)
         * [~:!\@\#$\%\^\&\*\(\)\+\=\{\};:'"|/\?><,\\\[\]\t\s\n]+ => match any of the characters in the look ahead one or more times
         * /g => make it global so it replaces things across the whole string
         */
        const replaceRegex = 
        // eslint-disable-next-line no-useless-escape
        /(?=[~:!\@\#$\%\^\&\*\(\)\+\=\{\};:'"|/\?><,\\\[\]\t\s\n])[~:!\@\#$\%\^\&\*\(\)\+\=\{\};:'"|/\?><,\\\[\]\t\s\n]+/g;
        const fileNameArray = fileName.split('.');
        let newFileName = '';
        if (fileNameArray.length >= 2) {
            fileNameArray.forEach((part, index) => {
                if (index < fileNameArray.length - 1) {
                    newFileName += part.replace(replaceRegex, '_');
                }
            });
            return `${newFileName.trim() === '' ? '_' : newFileName}.${fileNameArray.at(-1)}`;
        }
        return fileName.replace(replaceRegex, '_');
    };
    if (type === 'new') {
        const validFileExtensions = [
            'jpg',
            'jpeg',
            'png',
            'pdf',
            'doc',
            'docx',
            'odt',
            'xls',
            'xlsx',
            'ods',
        ];
        const onChangeFile = async (event) => {
            const validFile = validFileExtensions.some(extension => {
                //@ts-ignore
                if (event.target.files[0].name.endsWith(extension)) {
                    return true;
                }
                return false;
            });
            if (!validFile) {
                //@ts-ignore
                setUploadFileName(event.target.files[0].name);
                setShowUploadError(true);
                return;
            }
            setShowUploadError(false);
            if (event.target.files.length) {
                /**
                 * /^ => start of string
                 * (?=[a-z0-9\_\-]) => look ahead in the string for a pattern containing only alphanumeric and _-
                 * [a-z0-9\_\-]+ => any of these characters one or more times
                 * [\\s]{0} => no spaces in the string
                 * [\.]{1} => exactly one dot after the file name
                 * [a-z]+ => only alphabetical after the dot for the file extension one or more times
                 * $/ => end of string
                 * /i => case insensitive
                 *
                 */
                const validFileRegex = 
                // eslint-disable-next-line no-useless-escape
                /^(?=[a-z0-9\_\-])[a-z0-9\_\-]+[\\s]{0}[\.]{1}[a-z]+$/i;
                let renamedFile;
                if (!validFileRegex.test(event.target.files[0].name)) {
                    //create a new File object because the name property is read only in web.
                    renamedFile = new File([event.target.files[0]], formatFileName(event.target.files[0].name));
                }
                let isFound = false;
                for (let i = 0; i < userInfo.file.length; i++) {
                    //check if there is a renamed file
                    if (renamedFile) {
                        if (userInfo.file[i].filename === renamedFile.name) {
                            isFound = true;
                            break;
                        }
                    }
                    else {
                        if (userInfo.file[i].filename === event.target.files[0].name) {
                            isFound = true;
                            break;
                        }
                    }
                }
                if (isFound && props.showExistsingDocumentModalVisible) {
                    props.showExistsingDocumentModalVisible();
                    return;
                }
                props.setLoading?.(true);
                const formData = new FormData();
                const file = renamedFile ? renamedFile : event.target.files[0];
                // @ts-ignore
                formData.append('file', file);
                await User_service_1.default.uploadFile(formData);
                //@ts-ignore
                const fileName = event.target.files[0].name;
                props.setDeletableFiles([
                    ...props.deletableFiles,
                    renamedFile ? renamedFile.name : fileName,
                ]);
                props.reload();
            }
        };
        return (react_1.default.createElement(react_1.default.Fragment, null, react_native_1.Platform.OS === 'web' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("input", { type: "file", onChange: onChangeFile, id: "file-upload", accept: ".pdf, image/*, .doc, .docx, .odt, .xls, .xlsx, .ods", style: { display: 'none' } }),
            react_1.default.createElement("label", { htmlFor: "file-upload" },
                react_1.default.createElement(react_native_1.View, { style: [DocumentBox_style_1.styles.documentBox] },
                    react_1.default.createElement(atome_1.Icon, { icon: "plus" }),
                    react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.text] }, "DOKUMENT HINZUF\u00DCGEN"),
                    react_1.default.createElement(atome_1.Modal, { modalVisible: showUploadError, setModalVisible: setShowUploadError, cb: () => {
                            setShowUploadError(false);
                        } },
                        react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.textAlignCenter] },
                            "Fehler beim Upload von",
                            ' '),
                        react_1.default.createElement(atome_1.Text, { style: [
                                DocumentBox_style_1.styles.textAlignCenter,
                                DocumentBox_style_1.styles.marginVertical5,
                                DocumentBox_style_1.styles.textBold,
                            ] }, uploadFileName),
                        react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.textAlignCenter] }, "Erlaubte Dateiendungen:"),
                        react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.textAlignCenter] }, ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"))))))));
    }
    const openDocument = async () => {
        const fileResponse = await User_service_1.default.getFile(props.id);
        if (fileResponse.error) {
            react_native_1.Alert.alert('Es ist ein Fehler aufgetreten - Versuchen sie es später erneut');
            return;
        }
        const fileData = fileResponse.data;
        if (react_native_1.Platform.OS === 'web') {
            // @ts-ignore
            const byteCharacters = atob(fileData.file);
            const byteNumbers = [];
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers.push(byteCharacters.charCodeAt(i));
            }
            const byteArray = new Uint8Array(byteNumbers);
            const fileExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
            const fileExt = fileExtensions.find(ext => props.filename.endsWith(ext));
            let fileType = 'application/pdf;base64';
            if (fileExt !== 'pdf') {
                fileType = `image/${fileExt};base64`;
            }
            //@ts-ignore
            const file = new Blob([byteArray], { type: fileType });
            const fileURL = URL.createObjectURL(file);
            const supported = await react_native_1.Linking.canOpenURL(fileURL);
            if (supported) {
                await react_native_1.Linking.openURL(fileURL);
                URL.revokeObjectURL(fileURL);
            }
            else {
                react_native_1.Alert.alert(`Don't know how to open this URL: ${fileURL}`);
            }
        }
        else {
            props.openMobileDocument?.(fileData.file, props.filename);
        }
    };
    const extensionSwitch = (param) => {
        switch (param) {
            case 'jpg':
                return 'image/jpeg';
            case 'jpeg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'doc':
                return 'application/msword';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'xls':
                return 'application/vnd.ms-excel';
            case 'xlsx':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            default:
                return `application/${param}`;
        }
    };
    const convertBase64ToFile = (uri, sharedFilename) => {
        let arr = uri.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let uint8Array = new Uint8Array(n);
        while (n--) {
            uint8Array[n] = bstr.charCodeAt(n);
        }
        let file = new File([uint8Array], sharedFilename, { type: mime });
        return file;
    };
    const downloadDocument = async () => {
        const fileResponse = await User_service_1.default.getFile(props.id);
        if (fileResponse.error) {
            react_native_1.Alert.alert('Es ist ein Fehler aufgetreten - Versuchen sie es später erneut');
            return;
        }
        const fileData = fileResponse.data;
        const uri = fileData.file;
        const fileExtensions = [
            'pdf',
            'jpg',
            'jpeg',
            'png',
            'doc',
            'docx',
            'xls',
            'xlsx',
        ];
        let fileExt = fileExtensions.find(ext => props.filename.endsWith(ext));
        const sharedFilename = props.filename.includes('.')
            ? props.filename.substring(0, props.filename.indexOf('.'))
            : props.filename;
        if (fileExt) {
            // @ts-ignore
            let file = convertBase64ToFile(`data:${extensionSwitch(fileExt)};base64,${uri}`);
            (0, file_saver_1.saveAs)(file, sharedFilename);
        }
        else {
            react_native_1.Alert.alert('Die akzeptierte Erweiterungen sind: jpg, jpeg, png, pdf, doc, docx, xls, xlsx');
            return;
        }
    };
    const deleteDocument = async () => {
        props.setLoading?.(true);
        const response = await User_service_1.default.deleteFile(props.id);
        if (response.error) {
            console.log(response.message);
            return;
        }
        props.reload();
        setShowDelete(false);
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: openDocument },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: [DocumentBox_style_1.styles.documentBox, DocumentBox_style_1.styles.shadow] },
                react_1.default.createElement(atome_1.Modal, { modalVisible: showDelete, setModalVisible: setShowDelete, cb: deleteDocument, primaryButtonText: "L\u00F6schen" },
                    react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.textAlignCenter] }, "Wollen Sie das Dokument"),
                    react_1.default.createElement(atome_1.Text, { style: [
                            DocumentBox_style_1.styles.textAlignCenter,
                            DocumentBox_style_1.styles.marginVertical5,
                            DocumentBox_style_1.styles.textBold,
                        ] }, props.filename),
                    react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.textAlignCenter] }, "wirklich l\u00F6schen?")),
                props.thumb || props.thumb !== '' ? (react_1.default.createElement(react_native_1.View, { style: DocumentBox_style_1.styles.image },
                    react_1.default.createElement(react_native_1.Image, { source: {
                            height: react_native_1.Platform.OS === 'web' ? 175 : 90,
                            width: react_native_1.Platform.OS === 'web' ? 124 : 90,
                            uri: 'data:image/jpg;base64,' + props.thumb,
                        } }))) : (react_1.default.createElement(react_native_1.View, { style: DocumentBox_style_1.styles.noImage })),
                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.documentName] }, props.filename)),
                react_1.default.createElement(react_native_1.View, { style: [DocumentBox_style_1.styles.row, DocumentBox_style_1.styles.iconBubbleContainer] },
                    react_1.default.createElement(react_native_1.View, { style: [DocumentBox_style_1.styles.iconBubble] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: downloadDocument, hitSlop: { top: 15, bottom: 15, left: 15, right: 15 } },
                            react_1.default.createElement(TempDownloadButton_1.TempDownloadButton, null))),
                    props.canDelete && (react_1.default.createElement(react_native_1.View, { style: [DocumentBox_style_1.styles.iconBubble] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => setShowDelete(!showDelete), hitSlop: { top: 15, bottom: 15, left: 15, right: 15 } },
                            react_1.default.createElement(atome_1.Icon, { icon: 'garbagecan', size: react_native_1.Platform.OS === 'web' ? 20 : 18, color: react_native_1.Platform.OS === 'web' ? '#3db384' : 'red' })))))),
            react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.Text, { style: [DocumentBox_style_1.styles.documentName], numberOfLines: 1 }, props.filename)))));
}
exports.DocumentBox = DocumentBox;
